import { FC, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Loading } from 'components/primitive';
import PADetailsPage from './PADetailsPage.tsx';
import { PADetail } from 'interfaces/pa.detail.interface.ts';

const PADetailsContainer: FC = () => {
  const params = useParams();
  const location = useLocation();
  const dataState = location.state?.data;
  const parcelDataState = location.state?.parcelData;
  const markerDataState = location.state?.markerData;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<PADetail>();
  const [parcelData, setParcelData] = useState<any>();
  const [markerData, setMarkerData] = useState<any>();
  const [newEntry, setNewEntry] = useState<boolean>(true);

  useEffect(() => {
    if (dataState) {
      setData(dataState);
      setNewEntry(false);
      setLoading(false);
    } else if (parcelDataState) {
      setParcelData(parcelDataState);
      setLoading(false);
    } else if (markerDataState) {
      setMarkerData(markerDataState);
      setLoading(false);
    }
  }, [params, dataState, parcelDataState]);

  return (
    <>
      {loading && <Loading message={'Loading data'} />}
      {!loading && (
        <PADetailsPage
          data={data}
          newEntry={newEntry}
          parcelId={params.parcelId}
          parcelData={parcelData}
          markerData={markerData}
        />
      )}
    </>
  );
};

export default PADetailsContainer;
